import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SuperAdminPageLayout from '../../../layout/SuperAdminPageLayout';
const EditEditorPage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    return (_jsx(SuperAdminPageLayout, { title: t('admin.edit_editor'), unitIid: id, formType: 'edit', unit: 'editor' }));
};
export default EditEditorPage;
